import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export async function createCheckout(payload) {
  const { data } = await axios.post(`${API}/payments/checkout`, payload);
  return data; // { checkout_url, session_id }
}

export async function getPaymentStatus(sessionId) {
  const { data } = await axios.get(`${API}/payments/status/${sessionId}`);
  return data;
}

export async function getReceipt(sessionId) {
  const { data } = await axios.get(`${API}/payments/receipt/${sessionId}`);
  return data;
}

export async function getPayoutStatement(sessionId) {
  const { data } = await axios.get(`${API}/payments/payout-statement/${sessionId}`);
  return data;
}

// Idempotent: asks the backend to email the designer for payout instructions
// once the case reaches "Pending Designer Payment". Safe to call multiple times.
export async function requestPayoutInfo(sessionId) {
  const { data } = await axios.post(`${API}/payments/request-payout-info/${sessionId}`);
  return data;
}

// LAUNCH50 promo — UX-only validation (does NOT consume a use). Server re-validates
// and recomputes all financials at checkout / payment confirmation.
export async function validatePromo(code, labId) {
  const { data } = await axios.post(`${API}/promo/validate`, { code, lab_id: labId });
  return data;
}

export async function adminStats(token, scope = "real") {
  const { data } = await axios.get(`${API}/admin/stats`, {
    headers: { "X-Admin-Token": token }, params: { scope },
  });
  return data;
}
export async function adminUsers(token) {
  const { data } = await axios.get(`${API}/admin/users`, { headers: { "X-Admin-Token": token } });
  return data.users;
}
export async function adminUserDetail(token, uid) {
  const { data } = await axios.get(`${API}/admin/users/${uid}`, { headers: { "X-Admin-Token": token } });
  return data;
}
export async function adminCases(token) {
  const { data } = await axios.get(`${API}/admin/cases`, { headers: { "X-Admin-Token": token } });
  return data.cases;
}

// Recovers Firebase Auth accounts that have no Firestore user doc (onboarding froze
// after Auth creation). Idempotent: never deletes or duplicates.
export async function adminReconcileUsers(token) {
  const { data } = await axios.post(`${API}/admin/reconcile-users`, {}, { headers: { "X-Admin-Token": token } });
  return data; // { orphansFound, recovered, orphans }
}

// ---- Admin (payout panel) ----
export async function adminListPayments(token) {
  const { data } = await axios.get(`${API}/admin/payments`, { headers: { "X-Admin-Token": token } });
  return data.payments;
}

export async function adminMarkPayout(token, sessionId) {
  const { data } = await axios.post(`${API}/admin/payments/${sessionId}/payout`, {}, { headers: { "X-Admin-Token": token } });
  return data;
}

// Re-sends the payment-confirmation emails for a PAID transaction. Never charges,
// refunds or modifies the payment — only re-sends and records the attempt.
export async function adminResendPaymentEmail(token, sessionId) {
  const { data } = await axios.post(`${API}/admin/payments/${sessionId}/resend-email`, {}, { headers: { "X-Admin-Token": token } });
  return data; // { status, sent, resent_at, resend_configured }
}

// ---- Admin moderation (P3 users / P4 cases) ----
const _hdr = (token) => ({ headers: { "X-Admin-Token": token } });

export async function adminSuspendUser(token, uid, suspend = true) {
  const { data } = await axios.post(`${API}/admin/users/${uid}/suspend?suspend=${suspend}`, {}, _hdr(token));
  return data;
}
export async function adminDeleteUser(token, uid) {
  const { data } = await axios.delete(`${API}/admin/users/${uid}`, _hdr(token));
  return data;
}
export async function adminHideCase(token, caseId, hidden = true) {
  const { data } = await axios.post(`${API}/admin/cases/${caseId}/hide?hidden=${hidden}`, {}, _hdr(token));
  return data;
}
export async function adminDeleteCase(token, caseId) {
  const { data } = await axios.delete(`${API}/admin/cases/${caseId}`, _hdr(token));
  return data;
}
